export const environment = {
    baseAsForm: false,
    fallback: "https://stg.dingg.app/login",
    baseUrl: "https://stage.dingg.app/api/v1/"
};
